import script from "./CategoriesTreeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoriesTreeView.vue?vue&type=script&lang=ts&setup=true"

import "./CategoriesTreeView.vue?vue&type=style&index=0&id=cf3fed94&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf3fed94"]])

export default __exports__